"use client";

import { PropTypes } from "prop-types";
import { HeroContainer, BgImageContainer } from "./Hero.styles";
import { HeroContent } from "@components";
import { ParallaxLayer } from "@react-spring/parallax";
import Image from "next/image";
import { useInView } from "react-intersection-observer";

const Hero = ({ id, heroImage = {}, heroBackgroundImage = {} }) => {
  const [ioRef, inView] = useInView({
    threshold: 0.4,
  });

  return (
    <>
      <ParallaxLayer speed={0} factor={1}>
        <BgImageContainer>
          <Image
            src={heroBackgroundImage?.desktop}
            style={{ objectFit: "cover" }}
            fill
            placeholder={heroBackgroundImage?.placeholder}
            priority
            alt=""
          />
        </BgImageContainer>
      </ParallaxLayer>
      <ParallaxLayer speed={0.3}>
        <HeroContainer id={id} ref={ioRef}>
          <HeroContent heroImage={heroImage} inView={inView} />
        </HeroContainer>
      </ParallaxLayer>
    </>
  );
};

Hero.propTypes = {
  id: PropTypes.string,
  heroImage: PropTypes.shape({
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),

    alt: PropTypes.string,
  }),
  heroBackgroundImage: PropTypes.shape({
    url: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
    alt: PropTypes.string,
  }),
};

export default Hero;
